export default __webpack_public_path__ + "static/media/horizontal3.79d60b61.JPG";